const KEY = 'ss_cookie_consent';
const GA_ID = process.env.REACT_APP_GA4_ID;
let gaLoaded = false;

export const getConsent = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};

const clearGaCookies = () => {
  document.cookie.split(';').map(c => c.split('=')[0].trim()).filter(n => n.startsWith('_ga')).forEach((n) => {
    const host = window.location.hostname;
    [host, `.${host.replace(/^www\./, '')}`].forEach(d => { document.cookie = `${n}=; Max-Age=0; path=/; domain=${d}`; });
    document.cookie = `${n}=; Max-Age=0; path=/`;
  });
};

export const loadAnalytics = () => {
  if (gaLoaded || !GA_ID || !/^G-[A-Z0-9]+$/i.test(GA_ID)) return;
  gaLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false, anonymize_ip: true });
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
};

export const saveConsent = (analytics) => {
  localStorage.setItem(KEY, JSON.stringify({ analytics, at: new Date().toISOString() }));
  if (analytics) loadAnalytics();
  else {
    if (window.gtag && GA_ID) window[`ga-disable-${GA_ID}`] = true;
    clearGaCookies();
  }
};

export const initConsent = () => {
  if (getConsent()?.analytics) loadAnalytics();
};

export const openCookieSettings = () => window.dispatchEvent(new Event('open-cookie-settings'));
